import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  order: 1,
  marginRight: 'auto',
  marginTop: theme.spacing(6),
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(0),
  },
}));

export const StyledTitle = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isSubtitle',
})<{ isSubtitle: boolean }>(({ theme, isSubtitle }) => ({
  paddingRight: theme.spacing(5),
  paddingLeft: isSubtitle ? theme.spacing(4) : 0,
  color: isSubtitle ? theme.palette.grey.A100 : theme.palette.black.A100,
  [theme.breakpoints.down('sm')]: {
    paddingRight: theme.spacing(2),
    paddingLeft: isSubtitle ? theme.spacing(5) : 0,
    display: isSubtitle ? 'none' : 'initial',
  },
}));

export const StyledDivider = styled(Text)(({ theme }) => ({
  color: theme.palette.grey.A100,
}));

export const StyledSubTitle = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isLastTitle',
})<{ isLastTitle: boolean }>(({ theme, isLastTitle }) => ({
  marginRight: theme.spacing(6),
  marginLeft: theme.spacing(5),
  color: isLastTitle ? theme.palette.black.A100 : theme.palette.grey.A100,
  [theme.breakpoints.down('sm')]: {
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
  },
}));

export const StyledSmallTitle = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isLastTitle',
})(({ theme }) => ({
  color: theme.palette.black.A100,
}));
